import { z } from "zod/v4";
import { Form, FormProps } from "@/components/form";
import { checkCliente } from "../api/check-cliente";
import useFetch from "@/hooks/use-fetch";
import { Alert, CircularProgress, Collapse } from "@mui/material";
import { DataCache } from "@/components/display";

export const simpleClienteFormSchema = z.object({
    numeroDocumento: z.string().nonempty("Este campo es requerido"),
    razonSocial: z.string().nonempty("Este campo es requerido"),
    email: z.email(),
    telefono: z.string(),
    direccion: z.string()
})

export default function SimpleClienteForm({
    form,
    isEditMode = false,
    currentNumeroDocumento = "",
    ...props
}: FormProps<z.infer<typeof simpleClienteFormSchema>> & { isEditMode?: boolean; currentNumeroDocumento?: string }) {
    const { fetch, value, loading } = useFetch(async (ruc: string) => {
        if (ruc) return await checkCliente(ruc);
        return undefined;
    }, { debounceMs: 500 });

    const handleChangeRuc = (ruc: string) => {
        // No hacer fetch si el RUC es el mismo que el actual en modo edición
        if (isEditMode && ruc === currentNumeroDocumento) {
            return;
        }
        fetch(ruc);
        form.setFieldValue("numeroDocumento", ruc);
    }

    const personaExiste = value !== null && value !== undefined && value.numDocumento !== currentNumeroDocumento;

    return <Form form={form} gap={3} {...props}>
        {!isEditMode && <Collapse in={!loading && value !== undefined} sx={{ marginY: "-10px" }}>
            <DataCache data={value}>
                {value => <Alert severity="info">
                    {value == null ? "Se agregara una nueva persona" : "Se editara una persona existente"}
                </Alert>}
            </DataCache>
        </Collapse>}

        {isEditMode && <Collapse in={personaExiste}>
            <Alert severity="warning" sx={{ mb: 1 }}>
                Ya existe un cliente con ese Numero de Documento. No se pueden repetir Numero de Documento.
            </Alert>
        </Collapse>}

        <Form.TextField name="numeroDocumento" label="N° Documento" onChange={e => handleChangeRuc(e.target.value)}
            slotProps={{ input: { endAdornment: loading && <CircularProgress size={20} /> } }} />
        <Form.TextField name="razonSocial" label="Nombre" />
        <Form.TextField name="email" label="Email" />
        <Form.TextField name="telefono" label="Telefono" />
        <Form.TextField name="direccion" label="Dirección" />
        <Form.SubmitButton disabled={personaExiste && isEditMode}>Guardar</Form.SubmitButton>
    </Form>
}
